module.exports = __webpack_public_path__ + "media/images/team/tony_pancake-7a5f7bfd6cd834a65e48a997b5bc6c7e.png";